// ── IMAGE SLOTS (Bootcamp Class Ready) ────────────────────────────
// Hosted in the Impultienda store resources (Recursos).
const STORE = 'c9725558-2d6b-4a85-ae66-53c4d8fcef05';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/** iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Gamma Studio cover plus
 *  real pages 5 and 8 on the iMac, and the Impultienda bonus photos with their titles typed in. Pure white background. */
const IMAC = RES + '1792778505311_bcr-mockup-imac-7404ccd1.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the Gamma Studio book (9:16): p.4 (corrected), 8, 9 (corrected), 10, 36, 39 — same order as pageCaptions */
export const pageImages: string[] = [
  RES + '1792778509681_bcr-pagina-04-plan-q1-d835ad54.webp',
  RES + '1792778513557_bcr-pagina-08-clase-01-plan-fac054f9.webp',
  RES + '1792778518014_bcr-pagina-09-clase-01-coach-7c8c3996.webp',
  RES + '1792778522902_bcr-pagina-10-clase-01-run-28b44883.webp',
  RES + '1792778526891_bcr-pagina-36-clase-10-tests-b3c1143e.webp',
  RES + '1792778531452_bcr-pagina-39-planner-d0c8bc19.webp',
];
export const pageCaptions: string[] = [
  'Your 52-week plan (Q1)',
  'Class 01 · class plan',
  'Class 01 · coach it',
  'Class 01 · run it',
  'Class 10 · progress tests',
  'Class planner + progress tracker',
];
/** 5 bonus covers (titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792778535133_bcr-bono-1-estaciones-c29ad826.webp',
  RES + '1792778538775_bcr-bono-2-espacios-2e130e07.webp',
  RES + '1792778542864_bcr-bono-3-finishers-0ef76aa7.webp',
  RES + '1792778546309_bcr-bono-4-cues-59bf9f04.webp',
  RES + '1792778552028_bcr-bono-5-clientes-da05b8a1.webp',
];
